<template>
    <WebpImage
        :src="bonImgUrl(`quests/awardsIcons/${iconName.toLowerCase()}`, 'png')"
        :class="iconClass"
        alt="Ikona odměny"
    />
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { bonImgUrl } from "../../utils/image-src";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";

const props = defineProps<{
    iconName: string;
}>();

const baseClass = "bonusomat-quests__award-icon";

const iconClass = computed(() => {
    return `${baseClass} ${baseClass}--${props.iconName}`;
});
</script>
